<template>
    <DisplayTextWithRoute
        :value="value"
        routename="dashboard"
        :eventId="eventId"
        :deleted="row?.Deleted === true"
    />
</template>
<script lang="ts" setup>
import { DisplayTextWithRoute } from '@/components';
import { computed } from 'vue';

const props = defineProps<{
    value: string;
    row?: any;
}>();

const eventId = computed(() => {
    if (props.row && props.row['EventID'] !== undefined) {
        return props.row['EventID'];
    }
    return undefined;
});
</script>
